import Copy from '@resn/gozer-core/copy';

export default [
    {
        id: 'grey-rose',
        title: Copy.get(`xs1-configurator-color-color-gray-rose`),
    },
    {
        id: 'black',
        title: Copy.get(`xs1-configurator-color-color-black-black`),
    },
    {
        id: 'black-silver',
        title: Copy.get(`xs1-configurator-color-color-black-silver`),
    },
];
